import { useTranslation } from "react-i18next";
import { BiChevronLeft } from "react-icons/bi";
import { MdOutlineGroups, MdOutlinePerson } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Button from "shared/components/Button";
import Card from "shared/components/Card";
import Header from "shared/components/Header";
import { NAME_SPACES } from "shared/locales/constants";
import { PRICER_STRUCTURES, SCREENS } from "utils/constants";

const StructureSelect = ({ onSelect, onBack }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.PRICER);
  const STRUCTURE = t("STRUCTURE_SELECT", { returnObjects: true });
  const navigate = useNavigate();

  const goBack = onBack
    ? onBack
    : () => navigate(SCREENS.PRIVATE.ADMIN.PRICERS.LIST.path);

  return (
    <>
      <Header
        title={STRUCTURE.TITLE}
        subtitle={STRUCTURE.SUBTITLE}
        actions={[
          {
            text: STRUCTURE.BACK,
            onClick: goBack,
            type: "primary--outlined",
            icon: <BiChevronLeft size={20} />,
          },
        ]}
      />
      <div className="grid--2 gap-24 mt-24">
        <Card type="simple">
          <div
            onClick={() => onSelect(PRICER_STRUCTURES.INDIVIDUAL)}
            className="pricers-method-select__card"
          >
            <div className="pricers-method-select__icon pricers-method-select__icon--manual">
              <MdOutlinePerson size={32} color="#4c6ef5" />
            </div>
            <h3>{STRUCTURE.INDIVIDUAL_TITLE}</h3>
            <p className="pricers-method-select__description">
              {STRUCTURE.INDIVIDUAL_DESCRIPTION}
            </p>
            <Button
              type="primary--outlined"
              onClick={() => onSelect(PRICER_STRUCTURES.INDIVIDUAL)}
            >
              {STRUCTURE.INDIVIDUAL_ACTION}
            </Button>
          </div>
        </Card>
        <Card type="simple">
          <div
            onClick={() => onSelect(PRICER_STRUCTURES.ISOLATED_DUO_FAMILY)}
            className="pricers-method-select__card"
          >
            <div className="pricers-method-select__icon pricers-method-select__icon--import">
              <MdOutlineGroups size={32} color="#43a047" />
            </div>
            <h3>{STRUCTURE.STRUCTURE_TITLE}</h3>
            <p className="pricers-method-select__description">
              {STRUCTURE.STRUCTURE_DESCRIPTION}
            </p>
            <Button
              type="primary"
              onClick={() => onSelect(PRICER_STRUCTURES.ISOLATED_DUO_FAMILY)}
            >
              {STRUCTURE.STRUCTURE_ACTION}
            </Button>
          </div>
        </Card>
      </div>
    </>
  );
};

export default StructureSelect;
